import type { FormField } from './types';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function isAddressEmpty(value: unknown): boolean {
  if (value === undefined || value === null) return true;
  if (typeof value !== 'object') return true;
  return !Object.values(value as Record<string, unknown>).some(Boolean);
}

export function validateForm(
  fields: FormField[],
  values: Record<string, unknown>,
): Record<string, string> {
  const errors: Record<string, string> = {};
  for (const field of fields) {
    // Payment fields carry an amount selection, not a plain value; the amount is
    // validated when starting payment and recomputed server-side.
    if (field.type === 'payment') continue;
    // Descriptive text is prose, not an input — there is nothing to validate.
    if (field.type === 'paragraph') continue;
    const value = values[field.fieldId];
    const isEmpty =
      field.type === 'address'
        ? isAddressEmpty(value)
        : value === undefined || value === null || value === '' || value === false;
    if (field.required && isEmpty) {
      errors[field.fieldId] = `${field.label} is required`;
      continue;
    }
    if (field.type === 'email' && !isEmpty && !EMAIL_RE.test(String(value))) {
      errors[field.fieldId] = 'Please enter a valid email address';
    }
  }
  return errors;
}
